import type { ReactNode } from 'react';
import { anunciarOcultos } from '../../componentes/sensivel';

const COR = { 'tinta-1': 'text-tinta-1', ciano: 'text-ciano', verde: 'text-verde', perigo: 'text-perigo', laranja: 'text-laranja' };

/** Indicador do pipeline: valores longos (meta e realizado, valor ponderado) quebram de linha em vez de serem cortados. */
export function Kpi({ rotulo, valor, detalhe, cor = 'tinta-1' }: { rotulo: string; valor: ReactNode; detalhe?: ReactNode; cor?: keyof typeof COR }) {
  return (
    <div className="min-w-0 rounded-xl border border-borda bg-sup-1 p-4">
      <p className="kicker">{rotulo}</p>
      <p className={`numero mt-2 text-xl font-semibold break-words ${COR[cor]}`}>{anunciarOcultos(valor)}</p>
      {detalhe && <p className="mt-1 text-xs break-words text-tinta-3">{detalhe}</p>}
    </div>
  );
}
